import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const Wrapper = ({ children }) => (_jsx(Box, { as: "main", position: "relative", display: "grid", gridTemplateColumns: {
        "breakpoint.base": "repeat(4, [col-start] 1fr)",
        "breakpoint.lg": "repeat(12, [col-start] 1fr)",
        "breakpoint.xl": "repeat(12, [col-start] 1fr)",
    }, gap: {
        "breakpoint.base": "spacing.16",
        "breakpoint.lg": "spacing.24",
    }, maxWidth: {
        "breakpoint.base": "1024px",
        "breakpoint.xl": "1280px",
        "breakpoint.xxl": "1536px",
        "breakpoint.xxxl": "1920px",
    }, paddingHorizontal: {
        "breakpoint.base": "0",
        "breakpoint.lg": "spacing.32",
        "breakpoint.xl": "spacing.80",
    }, marginHorizontal: {
        "breakpoint.lg": "auto",
    }, paddingBottom: "spacing.16", paddingTop: {
        "breakpoint.base": "spacing.none",
        "breakpoint.lg": "spacing.16",
    }, testId: "aviv.CDP.main", unsafe_className: "Main", children: children }));
